import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/styles";
import { useReducer } from "react";
import ComponentLayoutWrapper from "src/components/core/ComponentLayoutWrapper";
import Layout from "src/components/core/Layout";
import PageLayoutController from "src/components/core/PageLayoutController";
import TransactionDesktop from "./TransactionDesktop";
import TransactionMobile from "./TransactionMobile";

const DESKTOP_LAYOUT = [["DESKTOP", "DESKTOP", "DESKTOP", "DESKTOP", "DESKTOP", "DESKTOP"]];

const MOBILE_LAYOUT = [["MOBILE", "MOBILE"]];

const Transactions = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [useDefaultTheme, toggle] = useReducer((theme: any): boolean => !theme, true);

  return (
    <Layout toggleTheme={toggle} useDefaultTheme={useDefaultTheme}>
      <PageLayoutController
        mobileLayout={MOBILE_LAYOUT}
        desktopLayout={DESKTOP_LAYOUT}
        spacing={15}
        container={true}>
        {!isMobile && (
          <ComponentLayoutWrapper
            gridArea="DESKTOP"
            state={{ isLoading: false }}
            fadeInDirection="none"
            loadingComponent={<></>}>
            <TransactionDesktop />
          </ComponentLayoutWrapper>
        )}

        {isMobile && (
          <ComponentLayoutWrapper
            gridArea="MOBILE"
            state={{ isLoading: false }}
            fadeInDirection="none"
            loadingComponent={<></>}>
            <TransactionMobile />
          </ComponentLayoutWrapper>
        )}
      </PageLayoutController>
    </Layout>
  );
};

export default Transactions;
